import React from 'react';
import { Button, Tooltip } from '@material-ui/core';
import ListItemText from '@material-ui/core/ListItemText';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import StyledMenuItem from './styledMenuItem';
import StyledMenu from './styledMenu';

import { getRoles, getUserName } from '../../utils/auth';
import IconAvatar from '../../assets/images/icons/custom-avatar.svg';

import './header.scss';
import '../ui/HeaderButton.scss';
import { logout } from '../../utils/api';
import { isTwoFactorEnabled } from '../../helpers/twoFactorAuthentication';
import { QUALITY_CHECKER, TRANSCRIBER } from '../../roles';
import {
  QUALITY_CONTROLLER_SECURITY_PATH,
  TRANSCRIBER_SECURITY_PATH,
} from '../../containers/SecurityPage';

// Only freelancers have a Security page
const SECURITY_PATHS = {
  [TRANSCRIBER]: TRANSCRIBER_SECURITY_PATH,
  [QUALITY_CHECKER]: QUALITY_CONTROLLER_SECURITY_PATH,
};

const useStyles = makeStyles((theme) => ({
  popperClose: {
    pointerEvents: 'none',
  },
  menuList: {
    minWidth: 256,
  },
  [theme.breakpoints.down('sm')]: {
    buttonText: {
      display: 'none',
    },
  },
}));

function ProfileMenu(props) {
  const { resetRecoilState } = props;
  const classes = useStyles();
  const [t] = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const history = useHistory();

  const userName = getUserName();
  const securityPath = isTwoFactorEnabled()
    ? SECURITY_PATHS[getRoles()?.[0]]
    : undefined;

  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }
  const handleLogout = () => {
    logout();
    if (resetRecoilState) {
      resetRecoilState();
    }
  };

  return (
    <>
      <Tooltip title={t('nav.profileTooltip')} placement="bottom">
        <Button
          aria-controls="ProfileMenu"
          className="HeaderButton"
          color="primary"
          aria-haspopup="true"
          variant="contained"
          onClick={handleClick}
        >
          <i>
            <img src={IconAvatar} alt="avatar" />
          </i>
          {userName && (
            <strong className={classes.buttonText}>{userName}</strong>
          )}
        </Button>
      </Tooltip>
      <StyledMenu
        className={classes.menuList}
        id="ProfileMenu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {securityPath && (
          <StyledMenuItem
            data-testid="security-button"
            onClick={() => {
              handleClose();
              history.push(securityPath);
            }}
          >
            <ListItemText primary={t('nav.security')} />
          </StyledMenuItem>
        )}
        <StyledMenuItem data-testid="logout-button" onClick={() => handleLogout()}>
          <ListItemText primary={t('nav.logout')} />
        </StyledMenuItem>
      </StyledMenu>
    </>
  );
}

ProfileMenu.propTypes = {
  resetRecoilState: PropTypes.func,
};
ProfileMenu.defaultProps = {
  resetRecoilState: null,
};
export default ProfileMenu;
